// extracted by mini-css-extract-plugin
export default {"empty":"styles_empty__vIQtw","empty__img":"styles_empty__img__tK+mI","empty__ttl":"styles_empty__ttl__UWv1n","empty__txt":"styles_empty__txt__RxxpP"};